import { FC } from 'react';
import styles from './FilteringControl.module.scss';
import cx from "classnames";

type Option = {
  value: string;
  label: string;
  onSelection?: () => void;
  disabled?: boolean;
  className?: string;
}

type Props = {
  options: Option[];
  value: string;
  className?: string;
  onChange?: (value: string) => void;
}

const FilteringControl: FC<Props> = ({ options, value, className, onChange }) => {

  return (
    <div className={cx(styles.container, className)}>
      {options.map(option => (
        <button
          key={option.value}
          className={cx(styles.button, option?.className, {[`${styles.active}`]: value === option.value})}
          onClick={option.onSelection ? option.onSelection : () => onChange && onChange(option.value)}
          disabled={option.disabled}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default FilteringControl;
